export const engageLibraryKeys = {
  all: ['tenantEngageLibrary'] as const,
  library: (businessId: string) => [...engageLibraryKeys.all, businessId] as const,
  job: (businessId: string, jobId: string) =>
    [...engageLibraryKeys.library(businessId), 'jobs', jobId] as const,
} as const;
